export const arrayUtilsMixin = {
  methods: {
    activeItems(array) {
      return array.filter(item => item.estatus_sistema === true)
    }
  }
}